const type = 'SET_CUSTOMER_ADDRESSES_HISTORY_LOADING';

const setCustomerAddressesHistoryLoading = (data) => ({
  data,
  type,
});

export { type };
export default setCustomerAddressesHistoryLoading;
